<template>
  <svg :width="width" :height="height" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5205 6.57336C22.0947 6.00261 21.4365 5.64158 20.7178 5.58533L5.85121 4.42846L5.58095 2.92406C5.33386 1.55039 4.22141 0.486655 2.81712 0.282562L2.54699 0.242953L0.939799 0.00867179C0.492058 -0.0559218 0.0754227 0.247265 0.00901298 0.687186C-0.0575399 1.12748 0.251657 1.53689 0.699398 1.6019V1.60153L2.57705 1.875L2.57748 1.87621C3.28299 1.97765 3.84298 2.51306 3.96726 3.2039L6.51192 17.3743C6.7507 18.7044 7.92633 19.6733 9.30099 19.6738H19.7582C20.211 19.6738 20.5777 19.3131 20.5777 18.8688C20.5777 18.4242 20.211 18.0635 19.7582 18.0635H9.30094C8.7221 18.0639 8.22579 17.6545 8.12532 17.0945L7.76937 15.1118H19.4265C20.5805 15.1118 21.5816 14.3294 21.8408 13.2245L22.9365 8.55936C23.0987 7.86969 22.9466 7.14486 22.5205 6.57336Z" :fill="color"/>
    <path d="M9.92616 20.537C8.95282 20.537 8.16406 21.313 8.16406 22.2689C8.16406 23.2249 8.95282 24.0001 9.92616 24.0001C10.8995 24.0001 11.6887 23.2249 11.6887 22.2689C11.6886 21.313 10.8995 20.537 9.92616 20.537Z" :fill="color"/>
    <path d="M17.7558 20.537C16.7822 20.537 15.9937 21.313 15.9937 22.2689C15.9937 23.2249 16.7822 24.0001 17.7558 24.0001C18.7291 24.0001 19.5183 23.2249 19.5183 22.2689C19.5183 21.313 18.7291 20.537 17.7558 20.537Z" :fill="color"/>
  </svg>
</template>

<script>
export default{
  name: 'purchaseIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '23'
    },
    height: {
      type: [String, Number],
      default: '24'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/PurchaseIcon.vue